import { render, staticRenderFns } from "./LabeledIcon.vue?vue&type=template&id=2ebb9de2"
import script from "./LabeledIcon.vue?vue&type=script&lang=js"
export * from "./LabeledIcon.vue?vue&type=script&lang=js"
import style0 from "./LabeledIcon.vue?vue&type=style&index=0&id=2ebb9de2&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports